module.exports = __webpack_public_path__ + "static/img/pc-09.de43963.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w9/pc-09.jpg
// module id = hfWt
// module chunks = 1